import { useFormContext } from '../formContext';
import FieldWrapper from './field-wrapper';
import { useController, UseControllerProps, FieldValues, Path } from 'react-hook-form';
import { GenderInput, GenderInputProps } from 'shared/ui/controls';

export interface GenderFieldProps<T extends FieldValues, K extends Path<T> = Path<T>>
  extends UseControllerProps<T>,
    Pick<GenderInputProps, 'isSolid' | 'size' | 'disabled'> {
  label?: string;
  required?: boolean;
  name: K;
}

export const GenderField = <T extends FieldValues, K extends Path<T>>({
  label = 'Gender',
  required,
  isSolid,
  size,
  disabled,
  ...props
}: GenderFieldProps<T, K>) => {
  const { readOnly } = useFormContext();
  const {
    field,
    fieldState: { error }
  } = useController(props);

  const { value, onChange, name } = field;

  return (
    <FieldWrapper label={label} error={error} required={required}>
      <div className="d-flex align-items-center" style={{ minHeight: 46 }}>
        <GenderInput
          isSolid={isSolid}
          size={size}
          disabled={disabled || readOnly}
          value={value}
          onChange={onChange}
          name={name}
        />
      </div>
    </FieldWrapper>
  );
};
